import { render, staticRenderFns } from "./activeNoOrder.vue?vue&type=template&id=54df6c60&scoped=true"
import script from "./activeNoOrder.vue?vue&type=script&lang=js"
export * from "./activeNoOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df6c60",
  null
  
)

export default component.exports